import {
  Grid,
  Box,
  Typography,
  FormControlLabel,
  Radio,
  FormControl,
  RadioGroup,
} from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import Configs from "../../constants/Configs";
import DialogError from "../../components/CustomDialog/DialogWait";
import {
  getData,
  storeData,
  clearData,
  getAllStorage,
  callChoice,
} from "../../utils/GlobalHelper";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import Loading from "../../components/loading/loading";
import { makeStyles } from "@mui/styles";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import GlobalApi from "../../utils/GlobalApi";
import { isEmpty } from "lodash";
import qs from "qs";

const header = {
  headers: {
    Accept: "application/json",
  },
};
const useStyle = makeStyles({
  textPhone: {
    paddingRight: "5px",
    color: "var(--text-black)",
  },
  title_row: {
    color: "var(--primary)",
    fontFamily: "DB Heavent",
    marginTop: "25px",
    fontSize: "24px",
  },
  textError: {
    fontSize: "16px !important",
    fontFamily: "DB Heavent !important",
    color: "var(--red) !important",
  },
  btnRadioMain: {
    position: "relative",
    color: "var(--primary)",
    margin: "auto",
    marginBottom: "16px",
    width: "98%",
    boxShadow: "2px 3px 6px 0px #ccc",
    borderRadius: "6px",
  },
  BtnRadio: {
    width: "100%",
    fontFamily: "DB Heavent",
    "& label": {
      width: "100%",
      minHeight: "60px",
      margin: "auto",
      "& span.MuiRadio-root": {
        fontSize: "20px !important",
        marginRight: "44px",
        marginLeft: "6px",
      },
      "& span.MuiTypography-root": {
        fontSize: "20px !important",
      },
    },
    "& .radioOther span.MuiRadio-root": {
      marginRight: "4px",
    },
  },
  iconBank: {
    position: "absolute",
    width: "36px",
    left: "44px",
    top: "11px",
    pointerEvents: "none",
  },
});
const AtsList = (props) => {
  const classes = useStyle();
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const f7_ats = getData("f7_ats") ? getData("f7_ats") : "";
  const uploadImageBookBank = getData("uploadImageBookBank")
    ? getData("uploadImageBookBank")
    : "";
  const idc = getData("idc");
  const [isCheck, setIscheck] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalError, setIsModalError] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [translations, setTranslations] = useState("");
  const [valueRadio, setValueRadio] = useState("");
  const [isHideList, setIsHideList] = useState(true);
  const [atsList, setAtsList] = useState([]);
  const [atsData, setAtsData] = useState(
    getData("f7_ats") ? getData("f7_ats") : "",
  );
  const CODE_BANK_IMG = {
    BAY: "Bank_BAY.svg",
    KBANK: "Bank_KBANK.svg",
    BBL: "Bank_BBL.svg",
    KTB: "Bank_KTB.svg",
    SCB: "Bank_SCB.svg",
    TTB: "Bank_TTB.svg",
  };
  const { nameTH, nameEN, middlenameTH, middlenameEN, lastnameTH, lastnameEN } =
    idc;
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  let snapIdCard = getData("uploadImage");
  let uploadImgSign = getData("uploadImageSign");

  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) {
        setJumpPage(true);
      } else {
        const translation = getData("Translations");
        if (!isEmpty(translation)) {
          setTranslations(translation);
        } else {
          props.history.push("/");
        }
        if (!isEmpty(atsData)) {
          if (atsData.f7_isother === "0" || atsData.f7_isother === 0) {
            props.history.push("/summary");
          } else {
            if (!isEmpty(uploadImageBookBank)) {
              props.history.push("/summary");
            } else {
              checkAts();
            }
          }
        } else {
          checkAts();
        }
      }
    });
  }, []);
  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });

    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(uploadImgSign)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const handleChangeRadio = (e) => {
    setValueRadio(e.target.value);
    if (e.target.value !== "0") {
      let obj_ats = atsList.find((o) => o.BankAccountNo === e.target.value);
      const f7_bank_ats = {
        Id: obj_ats.BankId,
        ThName: obj_ats.BankNameTh,
        EnName: obj_ats.BankNameEn,
      };
      if (obj_ats) {
        setAtsData({
          f7_isother: "0",
          add_account_json: [
            {
              SAfba_Id: "0", //  fix เป็นค่า 0
              SAfba_SAmbk_Id: obj_ats.BankId, // "BankId"
              SAfba_SAmbkb_Id: obj_ats.BranchId, // "BranchId"
              SAfba_SAmbkt_Id: "", // เลขidของ ประเภทบัญชี ส่งค่าว่าง
              SAfba_AccountNo: obj_ats.BankAccountNo, // "BankAccountNo"
              SAfba_AccountName:
                lang === "th"
                  ? nameTH +
                    " " +
                    (middlenameTH !== "" ? middlenameTH : "") +
                    " " +
                    lastnameTH
                  : nameEN +
                    " " +
                    (middlenameEN !== "" ? middlenameEN : "") +
                    " " +
                    lastnameEN,
              SAfba_UseATS: obj_ats.ATSFlag, // ATSFlag ให้ตัดเงินด้วย ATS หรือไม่ใช่“1” ไม่ใช่“0”
              SAfba_UseDividend: "0", //การขอรับบริการเงินปันผล/ ดอกเบ้ียใช่“1” ไม่ใช่“0” fix เป็นค่า 0
            },
          ],
        });
        storeData("f7_bank_ats", f7_bank_ats);
      }
    }
  };
  const handleNext = async () => {
    if (valueRadio === "0") {
      clearData("f7_ats");
      clearData("f7_bank_ats");
      await goToAtsApply();
    } else {
      storeData("f7_ats", atsData);
      await saveComeback();
    }
    return;
  };
  const checkAts = async () => {
    setIsLoading(true);
    const checkuserinfo = getData("checkuserinfo");
    const { cardId } = checkuserinfo;
    const data = { id_card: cardId, listtype: "ATS" };
    const header = {
      headers: {
        Accept: "application/json",
      },
    };
    try {
      GlobalApi.post(
        `${Configs.baseAPIURL03}/form/current_ats/selbyidentity`,
        data,
        header,
      )
        .then(async (res) => {
          if (res.data.Data) {
            setIsHideList(false);
            setAtsList(res.data.Data);

            let obj = res.data.Data.find(
              (o) =>
                o.BankAccountNo ===
                f7_ats?.add_account_json?.[0]?.SAfba_AccountNo,
            );
            if (f7_ats && obj) {
              setValueRadio(f7_ats.add_account_json?.[0].SAfba_AccountNo);
            }
            setIsLoading(false);
          } else {
            // await goToAtsApply();
            await props.history.push("/ats_apply");
          }
        })
        .catch((er) => {
          // console.log(er);
          // console.log("get ats  error");
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      // console.log(error);
      // console.log("catch get ats error");
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  const saveComeback = async () => {
    setIsLoading(true);
    storeData("stamp_page", "SUMMARY");
    var last_stamp = JSON.stringify(await getAllStorage("SUMMARY"));
    const saveData = [
      {
        name: "save ats",
        url: `${Configs.baseAPIURL03}/form/bank_account/manp`,
        postData: {
          head_token: head_token,
          f7_isother: atsData.f7_isother,
          add_account_json: atsData.add_account_json,
        },
      },
      {
        name: "comeback",
        url: `${Configs.baseAPIURL03}/form/comeback/manp`,
        postData: {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: "SUMMARY",
        },
      },
    ];
    setIsLoading(true);
    try {
      await GlobalApi.post(saveData[0].url, saveData[0].postData, header)
        .then(async (res) => {
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            let title = "เกิดข้อผิดพลาด";
            setIsLoading(false);
            setIsModalError(true);
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          } else {
            // console.log("save" + saveData[0].name + "  success");
            try {
              await GlobalApi.post(
                saveData[1].url,
                saveData[1].postData,
                header,
              )
                .then(async (res) => {
                  if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
                    let mss =
                      res.data.Data[0].MsgDesc !== ""
                        ? res.data.Data[0].MsgDesc
                        : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
                    let title = "เกิดข้อผิดพลาด";
                    setIsLoading(false);
                    setIsModalError(true);
                    setModalErrorTitle(title);
                    setModalErrorDes(mss);
                  } else {
                    // console.log("save" + saveData[1].name + "  success");
                    await storeData("saveComebackComplete", true);
                    await props.history.push("/summary");
                    setIsLoading(false);
                  }
                })
                .catch((er) => {
                  // console.log(er);
                  // console.log("save " + saveData[1].name + "  error");
                  setIsLoading(false);
                  let title = "เกิดข้อผิดพลาด";
                  let mss =
                    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
                    getData("api_error")?.message +
                    ")";
                  setIsModalError(true);
                  setModalErrorTitle(title);
                  setModalErrorDes(mss);
                });
            } catch (error) {
              // console.log(error);
              // console.log("catch" + saveData[1].name + "  error");
              setIsLoading(false);
              setIsModalError(true);
            }
          }
        })
        .catch((er) => {
          // console.log(er);
          // console.log("save " + saveData[1].name + "  error");
          setIsLoading(false);
          let title = "เกิดข้อผิดพลาด";
          let mss =
            "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง <br>(" +
            getData("api_error")?.message +
            ")";
          setIsModalError(true);
          setModalErrorTitle(title);
          setModalErrorDes(mss);
        });
    } catch (error) {
      // console.log(error);
      // console.log("catch" + saveData[0].name + "  error");
      setIsLoading(false);
      setIsModalError(true);
    }
  };
  const goToAtsApply = async () => {
    await storeData("back_from_ats_apply", true);
    await props.history.push("/ats_apply");
  };
  const clickBack = async () => {
    await storeData("back_form_ats", true);
    await props.history.push("/attach_sign");
  };
  const maskAccount = (str) => {
    var xStr = str.substring(0, str.length - 5);
    return xStr + "XXXXX ";
  };

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.ats?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? clickBack() : "")}
          />
          <Loading status={isLoading} />
          <DialogError
            open={isModalError}
            isModel={setIsModalError}
            title={modalErrorTitle}
            massage={modalErrorDes}
            btn={"ตกลง"}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.ats}
                        clickBack={(e) => clickBack()}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={isMobile ? 16 : 9}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight
                            title={translations?.[lang]?.ats?.title}
                          />
                          {!isHideList ? (
                            <ScrollBarComponent
                              isCheck={isCheck}
                              onChangeCheck={setIscheck}
                              content={
                                <Box>
                                  <Typography className="font-title font-20">
                                    กรุณาเลือกบัญชีที่ต้องการหักบัญชีอัตโนมัติ
                                    (ATS)
                                  </Typography>
                                  <Grid className="pt-4 pb-4">
                                    <FormControl
                                      component="fieldset"
                                      className={classes.BtnRadio}
                                    >
                                      <RadioGroup
                                        aria-label="gender"
                                        name="controlled-radio-buttons-group"
                                        value={valueRadio}
                                        onChange={handleChangeRadio}
                                      >
                                        {atsList?.map((item, j) => (
                                          <div
                                            className={classes.btnRadioMain}
                                            key={j}
                                          >
                                            <FormControlLabel
                                              value={item.BankAccountNo}
                                              control={<Radio />}
                                              label={
                                                item.BankAbbr +
                                                "  " +
                                                maskAccount(item.BankAccountNo)
                                              }
                                            />
                                            <img
                                              className={classes.iconBank}
                                              src={
                                                CODE_BANK_IMG[item.BankAbbr]
                                                  ? "images/" +
                                                    CODE_BANK_IMG[item.BankAbbr]
                                                  : "images/ATS.png"
                                              }
                                              alt={item.BankAbbr}
                                            />
                                          </div>
                                        ))}
                                        <div className={classes.btnRadioMain}>
                                          <FormControlLabel
                                            className={"radioOther"}
                                            // onClick={() =>
                                            //   goToAtsApply()
                                            // }
                                            value="0"
                                            control={<Radio />}
                                            label="เพิ่มบัญชีใหม่"
                                          />
                                        </div>
                                      </RadioGroup>
                                    </FormControl>
                                  </Grid>
                                  <span className="font-title font-normal font-20  font-DBHeavent">
                                    หมายเหตุ: หากต้องการใช้บริการ DAOL SEC
                                    Wealth Advice กรุณาเลือกธนาคารกสิกรไทย
                                    หรือรนาคารไทยพาณิชย์เท่านั้น
                                  </span>
                                </Box>
                              }
                            ></ScrollBarComponent>
                          ) : (
                            ""
                          )}{" "}
                          <ButtonRight
                            isDisbled={!valueRadio}
                            text={translations?.[lang]?.ats?.next}
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default memo(AtsList);
